
import { mapGetters } from 'vuex'

export default {
    props: {
        merge: {
            type: Object,
            default: () => ({})
        },
        showOnlyReleventRows: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            form: {
                lives_with_spouse: null,
                projected_lives_with_spouse: null,
                tax_filing_status: null,
                projected_tax_filing_status: null,
                current_income: null,
                year: null
            }
        }
    },
    fetch () {
        this.updateForm()
    },
    computed: {
        ...mapGetters([
            'yearMinus2',
            'calcIrmaaB',
            'calcIrmaaD',
            'effectiveTaxFilingStatus',
            'incomeOptionsFiledAsMap',
            'projectedIncomeDecrease',
            'projectedIncomeIncrease',
            'projectedIncomeChange',
        ]),
        effectiveStatus () {
            return this.effectiveTaxFilingStatus({ tax_filing_status: this.form.tax_filing_status, lives_with_spouse: this.form.lives_with_spouse })
        },
        effectiveProjectedStatus () {
            return this.effectiveTaxFilingStatus({ tax_filing_status: this.form.projected_tax_filing_status, lives_with_spouse: this.form.projected_lives_with_spouse })
        },
        marriedFilingLivingSeparately () {
            return (this.form.tax_filing_status === 'MARRIED_SEPARATELY' && this.form.lives_with_spouse === false) || (this.form.projected_tax_filing_status === 'MARRIED_SEPARATELY' && this.form.projected_lives_with_spouse === false)
        },
        taxFilingStatusChange () {
            return this.form.tax_filing_status !== this.form.projected_tax_filing_status
        },
        compact () {
            return this.showOnlyReleventRows && !this.taxFilingStatusChange
        },
    },
    watch: {
        merge: {
            deep: true,
            handler () {
                this.updateForm()
            }
        },
    },
    methods: {
        updateForm () {
            if (this.merge) {
                for (const key in this.merge) {
                    const value = this.merge[key]
                    this.$set(this.form, key, value)
                }
            }
        },
        tax_filing_status_sentence () {
            if (this.form.tax_filing_status === 'MARRIED_SEPARATELY') {
                return 'Married, filing separately'
            } else if (this.form.tax_filing_status === 'MARRIED_JOINT') {
                return 'Married, filing jointly'
            }
            return 'Single'
        },
        projected_tax_filing_status_sentence () {
            if (this.form.projected_tax_filing_status === 'MARRIED_SEPARATELY') {
                return 'Married, filing separately'
            } else if (this.form.projected_tax_filing_status === 'MARRIED_JOINT') {
                return 'Married, filing jointly'
            }
            return 'Single'
        }
    },
}
